<template>
  <div class="search-area container">
    <form>
      <div class="row">
        <div class="form-group col-4">
          <label>Fiscal year</label>
          <FiscalYearInput v-model="fiscalYear" />
        </div>
        <div class="form-group col-4">
          <label>Semester</label>
          <SemesterInput v-model="semester" />
        </div>
        <div class="form-group col-4">
          <label>Univeristy</label>
          <SelectUniversityInput v-model="university" />
        </div>
      </div>

      <div class="row">
        <div class="col-4 form-group">
          <label>Student number</label>
          <input type="text" class="form-control" v-model="studentNumber">
        </div>
        <div class="col-4 form-group">
          <label>Student name</label>
          <input type="text" class="form-control" v-model="studentNameJapanese">
        </div>
        <div class="col-4 form-group">
          <label>Student name (Alphabet)</label>
          <input type="text" class="form-control" v-model="studentName">
        </div>
      </div>

      <div class="row">
        <div class="col-4 form-group">
          <label>Email</label>
          <input type="text" class="form-control" v-model="email">
        </div>
        <div class="col-4">
        </div>
      </div>

      <div class="row">
        <div class="col-4 form-group">
          <label>Course Name</label>
          <input type="text" class="form-control" v-model="courseName">
        </div>
        <div class="col-8">
          <div class="row">
            <div class="col form-group">
              <label>Level</label>
              <LevelsInput v-model="levels" />
            </div>
          </div>
          <div class="row">
            <div class="col form-group">
              <label>Day of the week</label>
              <WeekdaysInput v-model="dayOfWeeks" />
            </div>
          </div>
          <div class="row">
            <div class="col form-group">
              <label>Period</label>
              <PeriodsInput v-model="periods" />
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-4 form-group">
          <label>Tutor ID</label>
          <input type="text" class="form-control" v-model="tutorId">
        </div>
        <div class="col-4 form-group">
          <label>Tutor name</label>
          <input type="text" class="form-control" v-model="tutorName">
        </div>
      </div>

      <div class="row">
        <div v-if="university" class="col-4 form-group">
          <label>Campus</label>
          <CampusesInput :belongsToUniversity="university" v-model="campuses" />
        </div>
        <div class="col-4 form-group">
          <label>Classroom</label>
          <input type="text" class="form-control" v-model="classroom">
        </div>
        <div class="col-4 form-group">
          <label>Booth</label>
          <input type="text" class="form-control" v-model="booth">
        </div>
      </div>

      <div class="row">
        <div class="col-4 form-group">
          <label>Absences count</label>
          <input type="number" class="form-control" v-model="absencesCount">
        </div>
        <div class="col-4 form-group">
          <label>Wetec ID</label>
          <input type="text" class="form-control" v-model="wetecId">
        </div>
        <div class="col-1">
          <label class="checkbox mt-5">
            <input type="checkbox" v-model="hasNotWetecId">
              not
          </label>
        </div>
      </div>
    </form>

    <div class="d-flex justify-content-end">
      <b-button pill variant="outline-secondary" @click="reset" class="mr-2" >
        Reset
      </b-button>
      <b-button pill variant="secondary" @click="search(1)">
        Search
      </b-button>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import _ from 'lodash'
import FiscalYearInput from '@/components/parts/inputItem/FiscalYearInput.vue'
import SemesterInput from '@/components/parts/inputItem/SemesterInput.vue'
import SelectUniversityInput from '@/components/parts/inputItem/SelectUniversityInput.vue'
import LevelsInput from '@/components/parts/inputItem/LevelsInput.vue'
import WeekdaysInput from '@/components/parts/inputItem/WeekdaysInput.vue'
import PeriodsInput from '@/components/parts/inputItem/PeriodsInput.vue'
import CampusesInput from '@/components/parts/inputItem/CampusesInput.vue'
import { StudentConditions } from '@/store/students/types'
import { periodType, weekdayKey } from '@/store/common.types'
import {
  Campus,
  Level,
  Semester,
  University,
} from '@/store/master/types'

@Component({
  components: {
    FiscalYearInput,
    SemesterInput,
    SelectUniversityInput,
    LevelsInput,
    WeekdaysInput,
    PeriodsInput,
    CampusesInput,
  },
})
export default class MailsSendBulkStudentsConditions extends Vue {
  @Prop() initialConditions!: StudentConditions

  private fiscalYear: number|null = null

  private semester: Semester|null = null

  private university: University|null = null

  private studentNumber: string = ''

  private studentNameJapanese: string = ''

  private studentName: string = ''

  private email: string = ''

  private courseName: string = ''

  private levels: Level[] = []

  private dayOfWeeks: weekdayKey[] = []

  private periods: periodType[] = []

  private tutorId: string = ''

  private tutorName: string = ''

  private campuses: Campus[] = []

  private classroom: string = ''

  private booth: string = ''

  private absencesCount: string = ''

  private wetecId: string = ''

  private hasNotWetecId: boolean = false

  private created() {
    this.fiscalYear = this.initialConditions?.fiscalYear || null
    this.semester = this.initialConditions?.semester || null
    this.university = this.initialConditions?.university || null
    this.studentNumber = this.initialConditions?.studentNumber || ''
    this.studentNameJapanese = this.initialConditions?.studentNameJapanese || ''
    this.studentName = this.initialConditions?.studentName || ''
    this.email = this.initialConditions?.email || ''
    this.courseName = this.initialConditions?.courseName || ''
    this.levels = this.initialConditions?.levels || []
    this.dayOfWeeks = this.initialConditions?.dayOfWeeks || []
    this.periods = this.initialConditions?.periods || []
    this.tutorId = this.initialConditions?.tutorId || ''
    this.tutorName = this.initialConditions?.tutorName || ''
    this.campuses = this.initialConditions?.campuses || []
    this.classroom = this.initialConditions?.classroom || ''
    this.booth = this.initialConditions?.booth || ''
  }

  /**
   * 検索条件変更
   */
  private search(): void {
    const conditions: StudentConditions = {
      fiscalYear: this.fiscalYear,
      semester: this.semester,
      university: this.university,
      studentNumber: this.studentNumber,
      studentNameJapanese: this.studentNameJapanese,
      studentName: this.studentName,
      email: this.email,
      courseName: this.courseName,
      levels: this.levels,
      dayOfWeeks: this.dayOfWeeks,
      periods: this.periods,
      tutorId: this.tutorId,
      tutorName: this.tutorName,
      campuses: this.campuses,
      classroom: this.classroom,
      booth: this.booth,
      absencesCount: this.absencesCount !== '' ? Number(this.absencesCount) : null,
      wetecId: this.wetecId,
      hasNotWetecId: this.hasNotWetecId,
    }

    this.$emit('changeConditions', conditions)
  }

  /**
   * 検索条件をリセット
   */
  private reset(): void {
    this.fiscalYear = null
    this.semester = null
    this.university = null
    this.studentNumber = ''
    this.studentNameJapanese = ''
    this.studentName = ''
    this.email = ''
    this.courseName = ''
    this.levels = []
    this.dayOfWeeks = []
    this.periods = []
    this.tutorId = ''
    this.tutorName = ''
    this.campuses = []
    this.classroom = ''
    this.booth = ''
    this.absencesCount = ''
    this.wetecId = ''
    this.hasNotWetecId = false

    this.search()
  }
}
</script>

<style scoped>

input[type="checkbox"] {
  margin-right:8px;
}

.checkbox {
  display: block;
  width: 65px;
}

</style>
